import { render, staticRenderFns } from "./FilesStudentSection.vue?vue&type=template&id=cd42c2ee&scoped=true"
import script from "./FilesStudentSection.vue?vue&type=script&lang=js"
export * from "./FilesStudentSection.vue?vue&type=script&lang=js"
import style0 from "./FilesStudentSection.vue?vue&type=style&index=0&id=cd42c2ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd42c2ee",
  null
  
)

export default component.exports